import { safeParseJSON } from '../../../utils/jsonValidator';

export function normalizeConfig(fullJson) {
    if (!fullJson?.configuration) return {};
    try {
        const parsed = typeof fullJson.configuration === 'string'
            ? JSON.parse(fullJson.configuration)
            : fullJson.configuration;

        if (['BUTTON', 'FLOW_PROCESS', 'API'].includes(fullJson.type_action)) {
            return { button: [parsed], table: [], select_company: false };
        }
        return parsed;
    } catch { return {}; }
}

export function parseFlowProcess(raw) {
    if (!raw) return [];
    try {
        const p = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (Array.isArray(p)) return p;
        if (Array.isArray(p?.flow_process)) return p.flow_process;
        return [];
    } catch { return []; }
}

export function wrapFlowProcess(actions) {
    const list = Array.isArray(actions) ? actions : [];
    return { flow_process: list };
}

export function serializeFlowProcess(actions) {
    return JSON.stringify(wrapFlowProcess(actions));
}

export function parseConfigurationForEdit(typeAction, raw) {
    const parsed = safeParseJSON(raw);
    if (['BUTTON', 'FLOW_PROCESS', 'API'].includes(typeAction)) {
        return typeof parsed === 'object' && parsed !== null ? parsed : {};
    }
    return parsed;
}

export function serializeConfiguration(typeAction, config) {
    if (['BUTTON', 'FLOW_PROCESS', 'API'].includes(typeAction)) {
        const action = config?.accion ? config : safeParseJSON(config);
        return JSON.stringify(action);
    }
    if (typeof config === 'string') return config;
    return JSON.stringify(config ?? {});
}

export function normalizeInterfaceForForm(data) {
    if (!data) return data;

    const normalized = { ...data };

    if (['BUTTON', 'FLOW_PROCESS', 'API'].includes(data.type_action)) {
        normalized.configuration = parseConfigurationForEdit(data.type_action, data.configuration);
        normalized.flow_process = [];
    } else if (data.configuration) {
        normalized.configuration = safeParseJSON(data.configuration);
    }

    normalized.flow_process = parseFlowProcess(data.flow_process);

    return normalized;
}

export function buildInterfacePayload(values) {
    const typeAction = values.type_action === 'CHART_REPORT' ? 'MENU' : values.type_action;
    const payload = {
        ...values,
        type_action: typeAction,
    };

    if (['BUTTON', 'FLOW_PROCESS', 'API'].includes(typeAction)) {
        payload.configuration = serializeConfiguration(typeAction, values.configuration);
        payload.flow_process = null;
    } else if (typeAction === 'MENU') {
        payload.configuration = serializeConfiguration(typeAction, values.configuration);
        payload.flow_process = values.flow_process?.length
            ? serializeFlowProcess(values.flow_process)
            : (values.flow_process && typeof values.flow_process === 'string'
                ? values.flow_process
                : JSON.stringify({ flow_process: [] }));
        payload.work_flow_related = null;
    } else if (typeAction === 'SUBMENU') {
        payload.configuration = serializeConfiguration(typeAction, values.configuration);
        payload.flow_process = values.flow_process?.length
            ? serializeFlowProcess(values.flow_process)
            : (values.flow_process && typeof values.flow_process === 'string'
                ? values.flow_process
                : JSON.stringify({ flow_process: [] }));
        if (!payload.work_flow_related)
            payload.work_flow_related = null;
    } else if (typeAction === 'CHART_REPORT' || values.type_action === 'CHART_REPORT') {
        payload.work_flow_related = null;
    }

    return payload;
}

export function generateMockRows(visibleColumns, count = 9) {
    const statuses = ['ASIGNADA', 'EN USO', 'CERRADA'];
    return Array.from({ length: count }).map((_, i) => {
        const row = { _id: i + 1 };
        visibleColumns.forEach(col => {
            if (col.type === 'money') {
                const num = Math.floor(Math.random() * 9_000_000) + 100_000;
                row[col.id] = `$ ${num.toLocaleString('es-CO')}`;
            } else if (col.id === 'status') {
                row[col.id] = statuses[i % 3];
            } else {
                row[col.id] = `${col.label} ${count - i}`;
            }
        });
        return row;
    });
}
